import React, { useCallback, useEffect, useState } from "react";
import Header from "./components/Header";
import ScrollScrubHero from "./components/ScrollScrubHero";
import Work from "./components/Work";
import Capabilities from "./components/Capabilities";
import Profile from "./components/Profile";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { skillsData } from "./data/skills";
import { projectsData } from "./data/projects";
import { socialLinks } from "./data/socialLinks";
import "./App.css";

const HEADER_H = 68;

const App = () => {
  const [solid, setSolid] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const hero = document.querySelector(".hero");
      if (!hero) return;
      setSolid(hero.getBoundingClientRect().bottom <= HEADER_H);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  const navigate = useCallback((id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div className="app">
      <a className="skip-link" href="#work">
        İçeriğe geç
      </a>
      <Header solid={solid} onNavigate={navigate} />
      <main>
        <ScrollScrubHero />
        <div className="reel">
          <Work projects={projectsData} />
          <Capabilities skills={skillsData} />
          <Profile />
          <Contact socialLinks={socialLinks} />
        </div>
      </main>
      <Footer />
      <div className="grain" aria-hidden="true" />
    </div>
  );
};

export default App;
